import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import AppBar from '@material-ui/core/AppBar';
import { withStyles } from '@material-ui/core/styles';
import ExitToApp from '@material-ui/icons/ExitToApp';
import Drawer from '@material-ui/core/Drawer';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import NavBar from '../components/NavBar';
import { startLogout } from '../actions/authActions';


const drawerWidth = 240;

const styles = theme => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  drawerPaper: {
    position: 'relative',
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing.unit * 3,
    minWidth: 0, // So the Typography noWrap works
  },
  toolbar: theme.mixins.toolbar,
  flex: {
    flex: 1,
  },
});

export const AdminRoute = ({ isAuthenticated, component: Component, ...rest }) => {
  const { classes, startLogout, name, role } = {...rest};
  return (
    <Route
      {...rest}
        component={(props) => (
        isAuthenticated && role === 'admin' ? (
          <div className={classes.root}>
            <AppBar position="absolute" className={classes.appBar}>
              <Toolbar>
                <Typography variant="title" color="inherit" noWrap className={classes.flex}>
                  Petty Cash
                </Typography>
                <Button color="inherit" onClick={() => startLogout()}>
                  {name} : ({role}) Logout
                  <ExitToApp />
                </Button>
              </Toolbar>
            </AppBar>
            <Drawer variant="permanent" classes={{
              paper: classes.drawerPaper,
            }}>
               <div className={classes.toolbar} />
              <NavBar />
            </Drawer>
            <main className={classes.content}>
              <div className={classes.toolbar} />
                <Component {...props} />
            </main>
          </div>
        ) : (
          <Redirect to="/" />
        )
      )}
    />
)};

const mapStateToProps = (state) => {
  const { role, name } = state.auth;
  return ({
    isAuthenticated: !!state.auth.uid,
    role,
    name
  });
};

const mapDispatchToProps = (dispatch) => ({
  startLogout: () => dispatch(startLogout())
});

export default compose(
  withStyles(styles, {
    name: 'AdminRoute',
  }), connect(mapStateToProps, mapDispatchToProps))(AdminRoute);



// WEBPACK FOOTER //
// ./src/routers/AdminRoute.js